import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { JobInstance } from 'src/app/services/data/models/jobs/job-instance';
import { OrchestratorInstance } from 'src/app/services/data/models/jobs/orchestrator-instance';
import { Status } from 'src/app/services/data/models/jobs/status';
import { FSSnap } from 'src/app/utils/firestore/fs-snap';

const pageLimit = 100;

@Component({
    selector: 'app-orchestrator',
    templateUrl: './orchestrator.component.html',
    styleUrls: ['./orchestrator.component.scss'],
})
export class OrchestratorComponent {
    orchestrator?: FSSnap<OrchestratorInstance>;
    failedJobs?: FSSnap<JobInstance>[];

    constructor(private route: ActivatedRoute, private data: DataService) {
        this.route.params.subscribe(async (params) => {
          const orchestratorInstanceId = params['id'];
            this.orchestrator = await this.data.getBIOrchestratorById(
              orchestratorInstanceId
            );
            this.failedJobs = await this.data.getBIJobsByOrchestratorIdAndStatus(orchestratorInstanceId, Status.Failed, pageLimit)
        });
    }

    copyFirestoreLink(o: FSSnap<any>): void {
        navigator.clipboard.writeText(
            `https://console.firebase.google.com/project/${
                o.snap.ref.firestore.app.options.projectId
            }/firestore/data/${encodeURIComponent(o.snap.ref.path)}`
        );
    }
}
